import React from "react";


const SocialBar = () => {
  return (
    <div className="social-bar">

        <a className="btn-outline-light btn-social mx-1" href="https://twitter.com/Ceci11Garcia" target="blank" ><i className="fab fa-fw fa-twitter"></i></a>
                              
        <a className="btn-outline-light btn-social mx-1" href="https://www.youtube.com/@cecig" target="blank"><i className="fab fa-fw fa-youtube"></i></a>

        <a className="btn-outline-light btn-social mx-1" href="https://www.linkedin.com/in/cecilia-i-garcia" target="blank"><i className="fab fa-fw fa-linkedin"></i></a>                
            
 
            
    </div>
  );
};

export default SocialBar;